import React from 'react';

export default class ImportStateFromDebug extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			data: '',
			show: false,
		};
	}

	bindImport () {
		const { onImport } = this.props;
		const { data } = this.state;

		if (confirm('🔥 Уверены? При импорте все данные текущей страницы будут перетерты на то, что в поле ввода. 🔥')) {
			onImport(data);
		}

	}

	render() {
		const { data, show } = this.state;
		const classes = ['debug-import', 'for-admin'];
		if (!show) classes.push('not-showed');

		return (
			<div className={classes.join(' ')}>
				<div className="tags tags--grey tags--sm">
					<button onClick={() => this.setState({show: !show})} className="tag">{show ? 'Закрыть импорт' : 'Открыть импорт'}</button>
				</div>
				<textarea
					className="debug-import__text"
					value={data}
					onChange={e => this.setState({ data: e.target.value })}
				/>
				<button className="btn btn--action" onClick={() => this.bindImport()}>
					Выполнить
				</button>
			</div>
		);
	}
}
